export default "https://cdn-static.gokick.com/assets/c3e2404f2f1be1cd3bf75e8d7804f871d91db3b2/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";